<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Editar Banco</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <form [formGroup]="form">
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field
        class="input-tg mt-message-input w-2/12"
        appearance="outline"
      >
        <mat-label>Código</mat-label>
        <input matInput formControlName="code" />
      </mat-form-field>

      <mat-form-field
        class="input-tg mt-message-input w-2/12"
        appearance="outline"
      >
        <mat-label>Código Bancário</mat-label>
        <input matInput formControlName="code_bank" />
      </mat-form-field>

      <mat-form-field
        class="input-tg mt-message-input w-6/12"
        appearance="outline"
      >
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-slide-toggle class="w-2/12" formControlName="active">{{
        form.get('active')?.value ? 'Ativo' : 'Inativo'
      }}</mat-slide-toggle>
    </div>
    <div class="flex justify-end gap-4 items-center">
      <button
        mat-flat-button
        class="btn-tg w-2/12"
        [disabled]="form.invalid || loading"
        (click)="updateItem()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Salvar
        }
      </button>
    </div>
  </form>
</mat-card>
